module.exports = __webpack_public_path__ + "19ee2f0228f4ef377455b9dd07094732.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_header_hide.png
// module id = 78
// module chunks = 0 1 2 3 4